let timing = (window.performance && window.performance.timing) || null;

export default {
  data() {
    return {
      deep: 0,
    };
  },
  watch: {
    asyncData(newVal, oldVal) {
      if (!oldVal) {
        const node = this.$parent.lazyLoad
          ? this.$parent.$parent
          : this.$parent;
        if (
          node.nodeInfo.props.jumpEnum == 8 &&
          node.nodeInfo.type === "mc-baseImg"
        ) {
          return;
        }
        this.deep = 0;
        this.website_findParent(node, true, node);
        if (this.$root.firstScreenNode.includes(node.nodeInfo.id)) {
          //首屏埋点
          this.website_perf_trackFn();
        }
      }
    },
  },
  beforeCreate() { },
  created() {
    this.$emit("mc_common_mounted_event");
  },
  mounted() {
    const node = this.$parent.lazyLoad ? this.$parent.$parent : this.$parent;
    let isFirstScreenNode =
      this.$root.firstScreenNode &&
      this.$root.firstScreenNode.length > 0 &&
      this.$root.firstScreenNode.includes(node.nodeInfo.id);
    if (
      !this.hasOwnProperty("asyncData") &&
      node.nodeInfo.type !== "mc-baseImg"
    ) {
      this.deep = 0;
      this.website_findParent(node, false, node);
      if (isFirstScreenNode) {
        this.website_perf_trackFn();
      }
    } else if (
      node.nodeInfo.props.jumpEnum != "8" &&
      node.nodeInfo.type === "mc-baseImg"
    ) {
      var img = new Image();
      img.src = this.imgUrl;
      img.onload = () => {
        this.website_findParent(node, false, node);
        if (isFirstScreenNode) {
          this.website_perf_trackFn();
        }
      };
    } else if (
      node.nodeInfo.props.jumpEnum == "8" &&
      node.nodeInfo.type === "mc-baseImg"
    ) {
      var img = new Image();
      img.src = this.redCoverUrl;
      img.onload = () => {
        this.website_findParent(node, false, node);
        if (isFirstScreenNode) {
          this.website_perf_trackFn();
        }
      };
    }
  },
  methods: {
    website_findParent(node, isAsync, originNode) {
      /**
       * 将加载性能上报给最近的父容器节点
       */
      this.deep++;
      if (node.nodeInfo && node.nodeInfo.type === "mc-baseContainer") {
        this.$root.$emit(node.nodeInfo.id, {
          a: isAsync,
          nt: originNode.nodeInfo.type,
          ni: originNode.nodeInfo.id,
          nl: originNode.nodeInfo.label,
          nv: originNode.nodeInfo.version,
          t: Date.now() - window["_backendRequestFirstTime"],
          pt: timing ? Date.now() - timing.fetchStart : -1,
          ct: Date.now() - originNode.nodeCreatedTime,
          d: this.deep,
        });
      } else if (node.$parent) {
        this.website_findParent(node.$parent, isAsync, originNode);
      }
    },
    website_perf_trackFn() {
      if (this.$root.firstScreenNode.length === 2) {
        this.$root.firstScreenNode.push(null);
      } else {
        this.imageLoadEnd()
        // this._removeFirstSceenDefaultApp();
        this.allBridge
          .allEventTrack({
            category: "alle_page",
            action: "performance_fmp",
            value: timing
              ? {
                p_timeCost: Date.now() - timing.fetchStart,
                timeCost: Date.now() - window["_backendRequestFirstTime"],
              }
              : {
                timeCost: Date.now() - window["_backendRequestFirstTime"],
                p_timeCost: -1,
              },
          })
          .then((res) => { });
      }
    },
    _removeFirstSceenDefaultApp() {
      var dom = document.getElementById('firstSceenDefaultApp');
      var ldom = document.getElementById('_pploading-container');
      if (!dom) return
      ldom && ldom.remove()
      document.querySelector('body').classList.remove('scrollOverflow')
      this.fadeOut(dom, function () {
        dom.remove();
      }, 500)
    },
    fadeOut(e, oncomplete, time) {
      if (typeof e === "string") {
        e = document.getElementById(e);
      }
      time = time || 500;

      var ease = Math.sqrt;
      var start = (new Date()).getTime();
      _ppAnimate();

      function _ppAnimate() {
        var now = (new Date()).getTime();
        var elapsed = now - start;
        var fraction = elapsed / time;

        if (fraction < 1) {
          var opacity = 1 - ease(fraction);
          e.style.opacity = String(opacity);
          setTimeout(_ppAnimate, Math.min(25, time - elapsed));
        } else {
          e.style.opacity = "0";
          if (oncomplete) {
            oncomplete(e);
          }
        }
      }
    },
    imageLoadEnd() {
      this.$nextTick(item => {
        const largestImage = this.findLargestImage()
        if (largestImage) {
          let _this = this
          largestImage.onload = function () {
            _this._removeFirstSceenDefaultApp()
          };
          
        } else {
          this._removeFirstSceenDefaultApp()
        }
      })
    },
    findLargestImage() {
      let largestSize = 0;
      let largestImage = null;
      const root = document.querySelector('div.base-container[data-node-id=root]'),
        nodeList = root.querySelectorAll('img')
        
      for (let i = 0; i < nodeList.length; i++) {
        const image = nodeList[i];
        const imageSize = image.width * image.height;
        if (imageSize > largestSize) {
          largestSize = imageSize;
          largestImage = image;
        }
      }
      return largestImage;
    }
  },
};
